jQuery(function($) {
    const stateGeoBounds = {
        'AL': {minLat: 30.137, maxLat: 35.008, minLon: -88.473, maxLon: -84.888},
        'AK': {minLat: 51.214, maxLat: 71.365, minLon: -179.148, maxLon: -129.979},
        'AZ': {minLat: 31.332, maxLat: 37.004, minLon: -114.817, maxLon: -109.045},
        'AR': {minLat: 33.004, maxLat: 36.500, minLon: -94.619, maxLon: -89.644},
        'CA': {minLat: 32.539, maxLat: 42.009, minLon: -124.409, maxLon: -114.131},
        'CO': {minLat: 36.993, maxLat: 41.003, minLon: -109.045, maxLon: -102.042},
        'CT': {minLat: 40.980, maxLat: 42.050, minLon: -73.727, maxLon: -71.786},
        'DE': {minLat: 38.451, maxLat: 39.839, minLon: -75.788, maxLon: -75.048},
        'FL': {minLat: 24.396, maxLat: 31.000, minLon: -87.634, maxLon: -80.031},
        'GA': {minLat: 30.357, maxLat: 35.000, minLon: -85.605, maxLon: -80.840},
        'HI': {minLat: 18.910, maxLat: 22.235, minLon: -160.247, maxLon: -154.806},
        'ID': {minLat: 41.988, maxLat: 49.001, minLon: -117.243, maxLon: -111.043},
        'IL': {minLat: 36.970, maxLat: 42.508, minLon: -91.512, maxLon: -87.495},
        'IN': {minLat: 37.771, maxLat: 41.761, minLon: -88.097, maxLon: -84.784},
        'IA': {minLat: 40.375, maxLat: 43.501, minLon: -96.639, maxLon: -90.140},
        'KS': {minLat: 36.993, maxLat: 40.003, minLon: -102.051, maxLon: -94.601},
        'KY': {minLat: 36.497, maxLat: 39.147, minLon: -89.571, maxLon: -81.964},
        'LA': {minLat: 28.921, maxLat: 33.019, minLon: -94.043, maxLon: -88.817},
        'ME': {minLat: 42.977, maxLat: 47.461, minLon: -71.084, maxLon: -66.926},
        'MD': {minLat: 37.911, maxLat: 39.723, minLon: -79.487, maxLon: -75.048},
        'MA': {minLat: 41.186, maxLat: 42.887, minLon: -73.508, maxLon: -69.928},
        'MI': {minLat: 41.696, maxLat: 48.305, minLon: -90.418, maxLon: -82.414},
        'MN': {minLat: 43.501, maxLat: 49.384, minLon: -97.239, maxLon: -89.491},
        'MS': {minLat: 30.178, maxLat: 34.996, minLon: -91.655, maxLon: -88.098},
        'MO': {minLat: 35.995, maxLat: 40.613, minLon: -95.774, maxLon: -89.098},
        'MT': {minLat: 44.358, maxLat: 49.001, minLon: -116.050, maxLon: -104.039},
        'NE': {minLat: 39.999, maxLat: 43.001, minLon: -104.053, maxLon: -95.307},
        'NV': {minLat: 35.001, maxLat: 42.002, minLon: -120.005, maxLon: -114.041},
        'NH': {minLat: 42.697, maxLat: 45.305, minLon: -72.557, maxLon: -70.610},
        'NJ': {minLat: 38.928, maxLat: 41.357, minLon: -75.561, maxLon: -73.893},
        'NM': {minLat: 31.332, maxLat: 37.000, minLon: -109.050, maxLon: -103.001},
        'NY': {minLat: 40.496, maxLat: 45.015, minLon: -79.762, maxLon: -71.856},
        'NC': {minLat: 33.848, maxLat: 36.588, minLon: -84.321, maxLon: -75.460},
        'ND': {minLat: 45.935, maxLat: 49.000, minLon: -104.048, maxLon: -96.554},
        'OH': {minLat: 38.403, maxLat: 41.977, minLon: -84.820, maxLon: -80.519},
        'OK': {minLat: 33.619, maxLat: 37.002, minLon: -103.002, maxLon: -94.430},
        'OR': {minLat: 41.991, maxLat: 46.299, minLon: -124.566, maxLon: -116.463},
        'PA': {minLat: 39.719, maxLat: 42.269, minLon: -80.519, maxLon: -74.689},
        'RI': {minLat: 41.146, maxLat: 42.018, minLon: -71.861, maxLon: -71.120},
        'SC': {minLat: 32.034, maxLat: 35.215, minLon: -83.353, maxLon: -78.542},
        'SD': {minLat: 42.479, maxLat: 45.946, minLon: -104.057, maxLon: -96.436},
        'TN': {minLat: 34.982, maxLat: 36.676, minLon: -90.310, maxLon: -81.646},
        'TX': {minLat: 25.837, maxLat: 36.500, minLon: -106.645, maxLon: -93.508},
        'UT': {minLat: 36.997, maxLat: 42.001, minLon: -114.053, maxLon: -109.041},
        'VT': {minLat: 42.730, maxLat: 45.016, minLon: -73.437, maxLon: -71.464},
        'VA': {minLat: 36.541, maxLat: 39.466, minLon: -83.675, maxLon: -75.242},
        'WA': {minLat: 45.543, maxLat: 49.002, minLon: -124.730, maxLon: -116.916},
        'WV': {minLat: 37.201, maxLat: 40.638, minLon: -82.644, maxLon: -77.719},
        'WI': {minLat: 42.491, maxLat: 47.309, minLon: -92.889, maxLon: -86.249},
        'WY': {minLat: 40.994, maxLat: 45.006, minLon: -111.056, maxLon: -104.052}
    };

    const usGeoBounds = {minLat: 24.396, maxLat: 49.384, minLon: -124.84, maxLon: -66.885};

    function projectWebMercator(lng, lat, bbox, size) {
        // Convert longitude/latitude to radians
        const longitude = (lng * Math.PI) / 180;
        const latitude = (lat * Math.PI) / 180;

        // Mercator projection formulas
        const mercatorX = longitude;
        const mercatorY = Math.log(Math.tan(Math.PI / 4 + latitude / 2));

        // Project bounding box
        const x0 = (bbox.minLng * Math.PI) / 180;
        const x1 = (bbox.maxLng * Math.PI) / 180;
        const y0 = Math.log(Math.tan(Math.PI / 4 + (bbox.minLat * Math.PI) / 360));
        const y1 = Math.log(Math.tan(Math.PI / 4 + (bbox.maxLat * Math.PI) / 360));

        // Normalize
        const xNorm = (mercatorX - x0) / (x1 - x0);
        const yNorm = (mercatorY - y0) / (y1 - y0);

        return {
            x: xNorm * size.width,
            y: (1 - yNorm) * size.height, // SVG Y axis is down
        };
    }

  
    states_with_offices.map(function(x){
        $('#states_map').find('#' + x[0]).addClass('has_office').attr('data-state', x[1]);
    })
    states_without_offices.map(function(x){
        $('#states_map').find('#' + x.value).addClass('additional_state').attr('data-state', x.label);
    })

    $('#states_map').find('.has_office').on('click', function(){
        let curr_state = $(this).attr('id');
        let curr_state_name = $(this).attr('data-state');
        let clone = $(this).clone(true);
        let bbox = $(this)[0].getBBox();
        let markerScale;
        const svgWidth = bbox.width;
        const svgHeight = bbox.height;
        const scale = Math.min(svgWidth / bbox.width, svgHeight / bbox.height);
        const translateX = (svgWidth - bbox.width * scale) / 2 - bbox.x * scale;
        const translateY = (svgHeight - bbox.height * scale) / 2 - bbox.y * scale;

        $('#states_map').find('.has_office').removeClass('active');
        $(this).addClass('active');
        $('.individual_state_cont').empty();
        $('.individual_state_cont').append('<h3>Offices in '+curr_state_name+':</h3>');
        $('.individual_state_cont').append('<div class="office_links"></div>');
        $('.individual_state_cont').append(`<svg id="individual_state" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 ${svgWidth+5} ${svgHeight+5}"><g id="state_group"></g><g id="markers"></g></svg>`);
        $('.individual_state_cont').find('#state_group').append(clone)[0].setAttribute('transform', `matrix(${scale},0,0,${scale},${translateX},${translateY})`);
        $('.individual_state_cont').find('#'+curr_state).removeAttr('data-state').off('click');

        if(svgHeight > 100 || svgWidth > 125){
            markerScale = .2
        } else{
            markerScale = 0.125;
        }
        offices_coordinates[curr_state].map(function(office){

            const minLat = stateGeoBounds[curr_state].minLat;
            const maxLat = stateGeoBounds[curr_state].maxLat;
            const minLon = stateGeoBounds[curr_state].minLon;
            const maxLon = stateGeoBounds[curr_state].maxLon
            const lat = office[0];
            const lng = office[1];

            const geoCords = projectWebMercator(lng, lat, {minLng: minLon, minLat: minLat, maxLng: maxLon, maxLat: maxLat}, {width: svgWidth, height: svgHeight});
            let svg = document.getElementById('markers');

            let flame = document.createElementNS("http://www.w3.org/2000/svg", "g");
            flame.setAttribute("class", "flame_path");
            flame.setAttribute("data-state", office[2]);
            flame.setAttribute("data-officeid", office[3]);

            let flame_line_one = document.createElementNS("http://www.w3.org/2000/svg", "path");
            flame_line_one.setAttribute("d", "M5.09,38.6s5,1.6,3.4,5.3c-1.6,3.6-12.9,23.1-6.6,41h7.6s-5.8-8.7-2.9-18.9c2.9-10.3,7.6-20.5,7.9-24.2s-3.9-6.6-3.9-6.6l-5.5,3.4Z");
            flame_line_one.setAttribute("class", "black_path")
            let flame_line_two = document.createElementNS("http://www.w3.org/2000/svg", "path");
            flame_line_two.setAttribute("d", "M14.79,84.9h6.3s-5.3-9.7-3.4-17.1c1.8-7.4,9.5-24.5,11.3-30.2,1.8-5.8,4.5-6.6-3.7-15.2l-5.8,3.2s7.4,2.1,5.5,7.1c-1.8,5-10.8,25-12.1,28.9-1.3,3.8-3.4,14.1,1.9,23.3Z");
            flame_line_two.setAttribute("class", "black_path")
            let flame_line_three = document.createElementNS("http://www.w3.org/2000/svg", "path");
            flame_line_three.setAttribute("d", "M27.69,84.6h7.6s-7.1-6.8-6.3-16c.8-9.2,17.4-43.9,18.4-47.3,1.1-3.4-2.1-9.7-6.6-13.7l-5.5,2.6s5,2.9,5.8,6c.8,3.2-1.6,10-3.9,15.5-2.3,5.5-13.5,29.2-13.7,32.4-.3,3.1-2.1,10,4.2,20.5Z");
            flame_line_three.setAttribute("class", "black_path")
            let flame_inner_drop = document.createElementNS("http://www.w3.org/2000/svg", "path");
            flame_inner_drop.setAttribute("d", "M62.39,88.8c11.5,0,21.5-9,21.5-20.5,0,0,0-3.7-1-6.6-.88-2.33-17.1-40.7-17.1-40.7,1.48-2.88,3.34-5.97,3.2-6.3-1.09-2.6-3.73-8.53-4-9.2-5.77,13.49-22.92,53.69-23.4,55.7-.9,3.9-.7,7.5-.7,7.5.8,13.3,10,20.1,21.5,20.1Z");
            flame_inner_drop.setAttribute("class", "white_path")
            let flame_outer_drop = document.createElementNS("http://www.w3.org/2000/svg", "path");
            flame_outer_drop.setAttribute("d", "M89.59,67.9c0,15-12.2,27.2-27.2,27.2-14.1,0-25.7-10.2-27-24,0,0-.5-5.1,1-10.4.9-3.7,25.4-60.7,25.4-60.7l3.2,5.5s-22.8,53.2-23.4,55.7c-.9,3.9-.7,7.5-.7,7.5.8,13.3,10,20.1,21.5,20.1s21.5-9,21.5-20.5c0,0,0-3.7-1-6.6-1.1-2.9-17.1-40.7-17.1-40.7l3.2-6.3s19.1,44,19.7,45.7c1,2.9,1.5,7.3.6,11.3");
            flame_outer_drop.setAttribute("class", "black_path");
            
            flame.appendChild(flame_line_one);
            flame.appendChild(flame_line_two);
            flame.appendChild(flame_line_three);
            flame.appendChild(flame_inner_drop);
            flame.appendChild(flame_outer_drop);

            // svg.appendChild(flame);
            // const bbox = flame.getBBox();
            // svg.removeChild(flame);
           

            let star = document.createElementNS("http://www.w3.org/2000/svg", "path");
            star.setAttribute("class", "star_path");
            star.setAttribute("d", "M61.99,25.19c-.12-.37-.44-.64-.83-.68l-19.8-2.46L32.92,3.95c-.16-.35-.52-.58-.91-.58h0c-.39,0-.74,.22-.91,.58l-8.47,18.09L2.84,24.5c-.39,.05-.71,.31-.83,.68-.12,.37-.02,.77,.27,1.04l14.59,13.63-3.78,19.58c-.07,.38,.08,.77,.39,1,.17,.13,.38,.19,.59,.19,.17,0,.33-.04,.48-.12l17.46-9.65,17.46,9.65c.34,.19,.76,.16,1.07-.07,.31-.23,.47-.62,.39-1l-3.78-19.58,14.56-13.63c.28-.27,.39-.67,.27-1.04Z");
            svg.appendChild(star);  
            const bbox = star.getBBox();
            svg.removeChild(star);

            // For center
            const offsetX = bbox.x + bbox.width/2;
            const offsetY = bbox.y + bbox.height/2;
            const tx = geoCords.x - offsetX*markerScale;
            const ty = geoCords.y - offsetY*markerScale;
            // flame.setAttribute("transform", `translate(${tx},${ty}) scale(${markerScale})`);
            // svg.appendChild(flame);

            star.setAttribute("transform", `translate(${tx},${ty}) scale(${markerScale})`);
            svg.appendChild(star);

            const branch_page_info = pages_with_branch_ids.pages.filter(x => x.branch_id == office[3])[0];
            if(branch_page_info != undefined){
                let city_name = (branch_page_info.city_name == null || (typeof branch_page_info.city_name === "string" && branch_page_info.city_name.trim().length === 0)) ? office[2] : branch_page_info.city_name;
                $('.office_links').append('<a href="' + branch_page_info.page_url +'" target="_blank">' + city_name + '</a>');
            } 
            // else{
            //     $('.office_links').append('<p>' + office[2] + '</p>');
            // }
        })

        //alphabetize offices
        let sorted = ($('.office_links').find('a')).sort(function(a, b){
            return $(a).text().localeCompare($(b).text());
        })

        $('.office_links').empty().append(sorted);

        

        
    });

    $('#states_map').find('#CO').trigger('click');



    $('body').append('<span id="tooltip-span"></span>');
    let tooltipSpan = $('#tooltip-span');

    window.onmousemove = function (e) {
        let x = e.clientX;
        let y = e.clientY;
        tooltipSpan.css('top' , (y - 20) + 'px');
        tooltipSpan.css('left' , (x + 20) + 'px');
        if($(e.target).parent().attr('data-state') !== undefined && $(e.target).parent().hasClass('has_office')){
            $('#tooltip-span').addClass('active').text('Show ' + $(e.target).parent().attr('data-state') + ' Offices');
        } 
        // else if($(e.target).attr('data-state') !== undefined){
        //     $('#tooltip-span').addClass('active').text($(e.target).attr('data-state') + ' Office');
        // }
        else{
            $('#tooltip-span').removeClass('active')
        }
    };
})